module.exports = __webpack_public_path__ + "static/img04-06467fb53b94ef0650f71065729df95a.jpg";